export default "__VITE_ASSET__CBhAqdVb__"